import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dSettingsTranslations() {
  return {
    title: {
      text: $localize`:@@scan3dSettings.title:Global Settings`,
      desc: 'Label for the scan 3d settings panel.',
    },
  } satisfies TranslationMap;
}
